<style lang="scss" src='./McPassword.scss' scoped></style>
<template src="./McPassword.html"></template>

<script>

export default {
  name: 'McPassword',
  components: {
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      required: true,
    },
    gClass: {
      required: false,
    },
    gRequired: {
      required: false,
      default: false,
    },
    gPlaceholder: {
      required: false,
      default: '',
    },
    showError: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return ({
      inputType: 'password',
    });
  },
  computed: {
    isValidPassword() {
      if (this.showError) {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.*[0-9]).{8,}$/;
        return regex.test(this.value);
      }
      return true;
    },
    inputClass() {
      if (!this.isValidPassword && this.showError) {
        return 'error';
      }
      return '';
    },
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },

    toggleInputType() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password';
    },
  },

  beforeCreate() {},

  created() {},

  mounted() {
  },

  beforeDestroy() {
  },

};

</script>
